/**
 * Swaps in bundled artwork when a remote image cannot be loaded, so a card never
 * renders as a broken image.
 *
 * Stories hydrated from api.gavel.ng carry a photograph on a host this app does
 * not control, so every one of them ships with a bundled `fallbackImage`. The
 * `data-fell-back` marker stops a missing fallback from looping the handler.
 */
export function onImageError(fallback?: string) {
    return (event: React.SyntheticEvent<HTMLImageElement>) => {
        const img = event.currentTarget;
        if (!fallback || img.dataset.fellBack) return;
        img.dataset.fellBack = 'true';
        img.src = fallback;
    };
}
